"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.buildList = function (links, level, link) {
            var columnCount = links.length;
            if (level === 1) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("section", { className: "absolute pin-t:100 pin-x z-20 transition-fast " + (_this.props.activeDropdown == link.handle
                            ? "opacity-100 visible pointer-events-auto" + (_this.props.previousDropdown ? " transition-delay-0" : "")
                            : "opacity-0 invisible pointer-events-none" + (_this.props.previousDropdown && _this.props.activeDropdown ? " transition-delay-25" : "")) },
                        React.createElement("div", { className: "border-t border-blue-grey-70 lg:block hidden" }),
                        React.createElement("div", { className: "bg-arctic py-3-2" },
                            React.createElement(Snippets.Container, { width: "xl", className: "mlg:px-11 md:px-4" },
                                React.createElement("ul", { className: "list-reset flex flex flex-row -mx-2-4" }, links.length
                                    ? links.map(function (list, i) {
                                        var children = list.links && list.links.length;
                                        var columnCounter = i + 1;
                                        return (React.createElement("li", { className: "block px-2-4 w-1/" + columnCount + " " + (columnCounter == columnCount ? "" : "border-r border-grey-light") + " transition-fast " + (_this.props.activeDropdown == link.handle
                                                ? "visible opacity-100 transition-delay-25"
                                                : "invisible opacity-0 transition-delay-none") + " " + (_this.props.activeDropdown ? "translate-y:0" : "translate-y:20x"), key: i },
                                            React.createElement("ul", { className: "list-reset" },
                                                React.createElement("li", { className: "" + (children ? "mb-0-8" : "mb-0-8") }, _this.buildLink(list, 2)),
                                                children ? _this.buildList(list.links, 2, list) : null)));
                                    })
                                    : null))))));
            }
            if (level === 2) {
                var isDisplayLogo_1 = link.handle === "shop-by-team" ? true : undefined;
                return links
                    ? links.map(function (link, i) { return (React.createElement("ul", { key: i, className: "list-reset block" },
                        React.createElement("li", null, _this.buildLink(link, 3, null, null, isDisplayLogo_1)))); })
                    : null;
            }
        };
        _this.buildLink = function (link, level, firstChild, lastChild, logo) {
            var levels = {
                1: (React.createElement("p", { className: "transition-fast visible translate-y:0 opacity-100 transition-delay-5" },
                    React.createElement("a", { href: link.url, title: link.title, "aria-label": link.title, role: "link", className: "inline-block text-base font-body font-semibold pt-1-6 pb-1-4 \n            hover:bg-grey-light hover:border-navy border-b-2 border-transparent leading-none no-underline whitespace-no-wrap transition-fast \n            " + (_this.props.activeDropdown == link.handle ? "bg-grey-light border-navy" : "") + " \n            " + (!firstChild && !lastChild ? " px-1-6" : null) + "\n            " + (firstChild ? " pr-1-6" : null) + " " + (lastChild ? " pl-1-6" : null) + "\n            " + (link.title == "Clearance" ? "text-red" : "text-navy-dark") + " hover:text-charcoal" },
                        React.createElement("span", null),
                        link.title))),
                2: (React.createElement("a", { href: link.url, title: link.title, "aria-label": link.title, role: "link", className: "block text-xs font-semibold tracking-wideless uppercase \n          text-navy-dark mb-0-6 transition-fast hover:text-grey-lighter leading-normal no-underline" }, link.title)),
                3: (React.createElement("a", { href: link.url, title: link.title, "aria-label": link.title, role: "link", className: "block text-base leading-normal tracking-normal \n          mb-0-6 transition-fast text-grey-lighter hover:text-navy-dark no-underline " + (logo ? "flex items-center" : "block") },
                    link.navigation_logo && (React.createElement("span", { className: "flex items-center" },
                        React.createElement("img", { src: link.navigation_logo.logo, className: "w-3-2 h-3-2" }),
                        "\u00A0\u00A0")),
                    React.createElement("span", { className: "leading-normal" }, link.title)))
            };
            return levels[level];
        };
        _this.state = {
            active: null
        };
        return _this;
    }
    Menu.prototype.render = function () {
        var _this = this;
        var _a = this.props, link = _a.link, firstChild = _a.firstChild, lastChild = _a.lastChild;
        var children = link.links && link.links.length;
        return (React.createElement("li", { className: "flex-grow group", onMouseEnter: children ? function () { return _this.props.handleHover(true, link.handle); } : null, onMouseLeave: children ? function () { return _this.props.handleHover(false, link.handle); } : null },
            this.buildLink(link, 1, firstChild, lastChild),
            children && this.buildList(link.links, 1, link)));
    };
    Menu.prototype.handleHover = function (status, id) {
        this.setState({
            active: status ? id : null
        });
    };
    return Menu;
}(React.PureComponent));
exports.Menu = Menu;
